module.exports = __webpack_public_path__ + "static/media/sabrina-intro-1.7ee08fd5.wav";